import { createRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';

/**
 * Legacy county-based route - redirects to flattened URL.
 * Server-side 301 is handled in Express SSR, this handles client-side navigation.
 */
const ServiceAreaCityRedirect = () => {
  const { city } = Route.useParams();

  useEffect(() => {
    window.location.replace(`/service-areas/${city}`);
  }, [city]);

  return null;
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service-areas/$county/$city',
  component: ServiceAreaCityRedirect,
});
